import dayjs from "dayjs";
import { ListPage } from "../../components/ListPage";
import { DT_FORMATS } from "../../helpers/constants";
import type { GoodsReceipt } from "../../api-models";

export default function GINDirectsListPage() {
  return (
    <ListPage<GoodsReceipt>
      title="GIN Direct"
      endpoint="/gin-directs"
      searchPlaceholder="Search doc no or delivery note..."
      linkTo={(r) => `/procurement/gin-directs/${r.id}`}
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "PO", render: (_, r) => r.po?.docNo },
        { title: "Supplier", render: (_, r) => r.supplier?.name },
        // The site is the point of this document — it is where the request was raised and
        // where the goods actually landed, so it leads over the store's own name.
        { title: "Site", render: (_, r) => r.site?.name },
        { title: "Store", render: (_, r) => r.location?.name },
        { title: "Delivery note", dataIndex: "deliveryNoteNo" },
        { title: "Received at", dataIndex: "receivedAt", sorter: true, render: (v) => dayjs(v).format(DT_FORMATS.dateTime) },
      ]}
    />
  );
}
